import ApplicationSourceChip from 'src/components/ApplicationSourceChip';
import StatusChip from 'src/components/StatusChip';
import {
  CUSTOMER_ENVIRONMENT_APPLICATION_STATUS,
  getCustomerEnvironmentApplicationStatusColor,
  getCustomerEnvironmentApplicationStatusLabel,
  getCustomerEnvironmentApplicationStatusOptions,
} from 'src/utils/enums/customerEnvironmentApplicationStatus';

const StatusCell = ({ status }) => {
  const color = getCustomerEnvironmentApplicationStatusColor(status);

  return (
    <StatusChip
      label={getCustomerEnvironmentApplicationStatusLabel(status)}
      color={color}
      backgroundColor={`${color}1F`}
      sx={{ height: 18, fontSize: '10px' }}
    />
  );
};

export const FILE_SETS_COLUMNS = [
  { key: 'hashOfFileAtPathHashes', label: 'File Set Hash', width: '42%', wrap: true },
  {
    key: 'status',
    label: 'Status',
    width: '12%',
    render: row => <StatusCell status={row.status} />,
  },
  {
    key: 'source',
    label: 'Source',
    width: '18%',
    render: row => (
      <ApplicationSourceChip source={row.originalSource} sx={{ height: 18, fontSize: '10px' }} />
    ),
  },
  { key: 'identifiedOn', label: 'Identified', width: '14%' },
  { key: 'fileCount', label: 'Files', width: '14%', align: 'right' },
];

// Opens on enabled file sets so the list matches the file set count shown for the app; clearing
// the status filter lists disabled sets as well.
export const DEFAULT_FILE_SET_FILTERS = {
  statuses: [CUSTOMER_ENVIRONMENT_APPLICATION_STATUS.Enabled],
};

export const FILE_SET_FILTER_OPTIONS = [
  {
    key: 'statuses',
    type: 'checkbox',
    label: 'Status',
    options: getCustomerEnvironmentApplicationStatusOptions(),
  },
];
